import { DigitalSignatureState } from "../../Global/Base/Crypto/ISignatureInfo";
import { ISignatureProviderSettings } from "../../Global/Base/Crypto/ISignatureProvider";

/**
 * Obsahuje nastavení a informace pro podepisovaný objekt.
 * @includeToDoc
 */
export class SignatureStreamSettings {
    /**
     * Nastavení providera.
     */
    public readonly providerSettings: ISignatureProviderSettings;

    /**
     * Aktuální stav podpisu.
     */
    public currentSignatureState = DigitalSignatureState.empty;

    /**
     * Instance aktuálního objektu
     */
    public readonly instanceId: string;

    /**
     * Atribut podepisovaného objektu.
     */
    public readonly attrName: string;

    /**
     * Odkaz na aktuálně nahrávaný soubor.
     */
    public currentFileStream: File | null = null;

    /**
     * Klíč pro crypto operace
     */
    public cryptoKey?: CryptoKey;

    constructor(providerSettings: ISignatureProviderSettings, instanceId: string, attrName: string, currentFileStream: File | null = null) {
        this.providerSettings = providerSettings;
        this.instanceId = instanceId;
        this.attrName = attrName;
        this.currentFileStream = currentFileStream;
    }
}
